import * as React from 'react';
import type { LucideIcon } from 'lucide-react';
import { Card, CardContent } from '@/components/ui';
import { cn } from '@/lib/utils';

/** Violet circular backdrop + Lucide icon — use above the title in dashed empty-state cards. */
export function DashboardEmptyStateIcon({ icon: Icon }: { icon: LucideIcon }) {
  return (
    <div className="flex justify-center mb-4">
      <div className="w-20 h-20 rounded-full bg-violet-100 dark:bg-violet-900/30 flex items-center justify-center">
        <Icon className="w-10 h-10 text-violet-500 dark:text-violet-400" aria-hidden />
      </div>
    </div>
  );
}

/** Standard dashed empty-state card for academy owner list pages. */
export function DashboardEmptyStateCard({
  children,
  className,
  contentClassName,
}: {
  children: React.ReactNode;
  className?: string;
  contentClassName?: string;
}) {
  return (
    <Card
      className={cn(
        'm-2.5 border-2 border-dashed border-gray-300 dark:border-gray-700 shadow-none',
        className
      )}
    >
      <CardContent className={cn('p-8 sm:p-10 text-center', contentClassName)}>{children}</CardContent>
    </Card>
  );
}
